import { Box, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import EvidenceResourcesTab from "../../../../Evidence/components/EvidenceResourcesTab";
import EvidenceLoadingSkeleton from "../../../../Evidence/components/common/EvidenceLoadingSkeleton";
import { CheckStatus } from "../../../../../utils/enums";

const EvidenceSetDetails = ({
  checkDetails,
  activeCheckId,
  checkCategory,
  onRefetch,
  loading,
  auditEndDate,
}) => {
  const theme = useTheme();

  // Loading state
  if (loading) {
    return <EvidenceLoadingSkeleton />;
  }

  // No check selected state
  if (!checkDetails) {
    return (
      <Box
        sx={{
          flex: 1,
          backgroundColor: "#FFFFFF",
          borderRadius: "12px",
          border: `1px solid ${theme.customColors.border.main}`,
          boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: 4,
        }}
      >
        <Typography
          sx={{
            fontSize: "15px",
            color: theme.customColors.text.secondary,
            textAlign: "center",
          }}
        >
          Select a check to view its details
        </Typography>
      </Box>
    );
  }

  // Render EvidenceResourcesTab - it handles all category logic and fallbacks
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        overflowX: "hidden",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          backgroundColor: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: alpha(theme.customColors.border.main, 0.7),
          borderRadius: "10px",
          "&:hover": {
            backgroundColor: alpha(theme.customColors.border.main, 0.7),
          },
        },
      }}
    >
      <EvidenceResourcesTab
        checkDetails={checkDetails}
        activeCheckId={activeCheckId}
        checkCategory={checkCategory}
        onRefetch={onRefetch}
        onRegisterRefetch={() => {}}
        isAuditorView={false}
        auditEndDate={auditEndDate}
        defaultStatusFilter={[CheckStatus.PASS]}
      />
    </Box>
  );
};

export default EvidenceSetDetails;
